/**
 * Body scroll lock - prevents the page from scrolling while a modal is open.
 *
 * Uses a reference counter so nested modals (e.g. a confirm dialog inside a
 * modal) don't release the lock when the inner one closes.
 *
 * Also compensates for the scrollbar width so the layout doesn't shift when
 * the scrollbar disappears.
 */

let count = 0

export function lockBodyScroll(): void {
  if (count === 0) {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
    document.body.style.overflow = 'hidden'
    if (scrollbarWidth > 0) document.body.style.paddingRight = `${scrollbarWidth}px`
  }
  count++
}

export function unlockBodyScroll(): void {
  count = Math.max(0, count - 1)
  if (count === 0) {
    document.body.style.overflow = ''
    document.body.style.paddingRight = ''
  }
}
